import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const JobDetails = () => {
  const { state } = useLocation();
  const navigate = useNavigate();

  const [jobPostDetail, setJobPostDetail] = useState(state?.data || {});
  const [currentIndex, setCurrentIndex] = useState(state?.index ?? 0);

  const jobList = state?.jobPostList?.all || [];

  const handleNext = () => {
    if (!jobList.length) return;
    const nextIndex =
      currentIndex === jobList.length - 1 ? 0 : currentIndex + 1;
    setCurrentIndex(nextIndex);
    setJobPostDetail(jobList[nextIndex]);
  };

  const handlePrevious = () => {
    if (!jobList.length) return;
    const prevIndex =
      currentIndex === 0 ? jobList.length - 1 : currentIndex - 1;
    setCurrentIndex(prevIndex);
    setJobPostDetail(jobList[prevIndex]);
  };

  return (
    <section className="ct_px_40 py-5">
      <div className="container-fluid">
        <div className="row"></div>
        <div className="row">
          <div className="col-md-12">
            <div
              class="d-flex align-items-center gap-md-5 gap-4 ct_pb_30 ct_mb_30 px-3"
              style={{ borderBottom: "1px solid #e6e6e6" }}
            >
              <h6 class="mb-0 ct_fs_16 ct_darkblue_text text-dark" onClick={() => navigate(-1)}>
                <span className="ct_back_login_text"><a className=""><i class="fa-solid fa-angle-left"></i></a></span>Back
              </h6>
              <div class="d-flex align-items-center gap-4">
                <a class="ct_nav_link" onClick={handlePrevious}>
                  <i class="fa-solid fa-chevron-left me-1"></i> Previous
                </a>
                <a class="ct_nav_link" onClick={handleNext}>
                  Next <i class="fa-solid fa-chevron-right ms-1"></i>
                </a>
              </div>
            </div>
            <div className="d-flex  gap-3 mb-2 align-items-center justify-content-between ct_flex_col_767 mb-2">
              <div class="d-flex gap-sm-5 gap-3  align-items-center">
                <div>
                  <span className="mb-0 ct_back_login_text">
                    {jobPostDetail?.job_title || ""}
                  </span>
                </div>
                <div>
                  <span class="ct_custom_badge">{jobPostDetail?.status || "Active"}</span>
                </div>
              </div>
              <div className="d-flex align-items-center gap-3">
                <button className="ct_yellow_btn ct_outline_grey ct_h_30 w-100 px-4 ct_w_100_575 ct_white_nowrap">
                  <svg width="16" height="16" className="me-2 ct_flex_shrink_0" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.5569 2.14488L2.58158 5.80421C2.53664 5.81916 2.49731 5.84742 2.46882 5.88525C2.44033 5.92308 2.42403 5.96868 2.42207 6.016C2.42012 6.06332 2.43261 6.11011 2.45789 6.15016C2.48316 6.19021 2.52002 6.22162 2.56358 6.24021L6.59691 7.96888C6.61805 7.97803 6.64119 7.98155 6.66409 7.9791C6.68699 7.97664 6.70886 7.9683 6.72758 7.95488L10.6816 5.12955C10.8042 5.04288 10.9549 5.19355 10.8682 5.31621L8.04291 9.27021C8.02972 9.28892 8.02156 9.3107 8.01923 9.33347C8.01689 9.35624 8.02046 9.37922 8.02958 9.40021L9.75758 13.4335C9.77611 13.4771 9.80747 13.514 9.84747 13.5394C9.88748 13.5647 9.93425 13.5772 9.98156 13.5754C10.0289 13.5735 10.0745 13.5572 10.1124 13.5288C10.1502 13.5004 10.1786 13.4611 10.1936 13.4162L13.8529 2.44021C13.8667 2.39907 13.8687 2.35491 13.8588 2.31268C13.8488 2.27045 13.8273 2.23183 13.7966 2.20115C13.766 2.17048 13.7273 2.14896 13.6851 2.13902C13.6429 2.12908 13.5981 2.13111 13.5569 2.14488Z" fill="#535862" />
                  </svg>
                  Share
                </button>
              </div>
            </div>
            <p class="ct_grey_text mb-0 ct_fs_14">
              <img
                src="../assets/img/location_darkbluie_icon.svg"
                className="me-2"
              />
              {jobPostDetail?.location || ""}
            </p>
          </div>
          <div className="col-md-12">
            <div class="">
              <div className="ct_outline_bg mt-4 pb-0">
                <div class="row">
                  <div class="col-lg-4 col-md-6 col-sm-6 ct_mb_20">
                    <small class="ct_grey_text ct_mb_10 ct_fs_14 d-block">
                      Category
                    </small>
                    <p className="mb-0 ct_fs_14 ct_darkblue_text">{jobPostDetail?.category || ""}</p>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-6 ct_mb_20">
                    <small class="ct_grey_text ct_mb_10 ct_fs_14 d-block">
                      Availability
                    </small>
                    <p className="mb-0 ct_fs_14 ct_darkblue_text">
                      {jobPostDetail?.candidate_availability || ""}
                    </p>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-6 ct_mb_20">
                    <small class="ct_grey_text ct_mb_10 ct_fs_14 d-block">
                      Work Approach
                    </small>
                    <p className="mb-0 ct_fs_14 ct_darkblue_text">{jobPostDetail?.candidate_location || ""}</p>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-6 ct_mb_20">
                    <small class="ct_grey_text ct_mb_10 ct_fs_14 d-block">
                      Experience
                    </small>
                    <p className="mb-0 ct_fs_14 ct_darkblue_text">{jobPostDetail?.years_of_experience || 0} Years</p>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-6 ct_mb_20">
                    <small class="ct_grey_text ct_mb_10 ct_fs_14 d-block">
                      Salary
                    </small>
                    <p className="mb-0 ct_fs_14 ct_darkblue_text">
                      {jobPostDetail?.salary_currency || "$"}{jobPostDetail?.min_salary || 0} - {jobPostDetail?.salary_currency || "$"}{jobPostDetail?.max_salary || 0}
                    </p>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-6 ct_mb_20">
                    <small class="ct_grey_text ct_mb_10 ct_fs_14 d-block">
                      License
                    </small>
                    <p className="mb-0 ct_fs_14 ct_darkblue_text">{jobPostDetail?.license || ""}</p>
                  </div>
                </div>
              </div>
              <div className="ct_mt_20 d-flex align-items-center gap-3">
                <span class="ct_skill_badge d-flex align-items-center gap-2">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_30_57669)">
                      <path
                        d="M10.9846 8.34915C12.352 8.34915 13.4663 7.13115 13.4663 5.64915C13.4663 4.18401 12.3577 3.02344 10.9846 3.02344C9.62286 3.02344 8.50257 4.20115 8.50257 5.66058C8.50829 7.13687 9.62286 8.34915 10.9846 8.34915ZM4.36629 8.47544C5.54971 8.47544 6.52057 7.41258 6.52057 6.10858C6.52057 4.83315 5.56114 3.80487 4.36629 3.80487C3.18286 3.80487 2.20629 4.85058 2.212 6.12001C2.21771 7.41858 3.18286 8.47544 4.36629 8.47544ZM10.9846 7.48172C10.1457 7.48172 9.42743 6.67744 9.42743 5.66058C9.42743 4.66058 10.1343 3.89115 10.9846 3.89115C11.8406 3.89115 12.5414 4.64944 12.5414 5.64887C12.5414 6.66601 11.8349 7.48172 10.9846 7.48172ZM4.36629 7.61944C3.66543 7.61944 3.068 6.94744 3.068 6.12001C3.068 5.31001 3.65943 4.66087 4.36629 4.66087C5.09 4.66087 5.67029 5.29858 5.67029 6.10858C5.67029 6.94744 5.07286 7.61944 4.36629 7.61944ZM1.172 13.7437H5.682C5.406 13.5886 5.19343 13.2437 5.23371 12.8934H1.02857C0.913714 12.8934 0.856286 12.8477 0.856286 12.7383C0.856286 11.3137 2.482 9.98087 4.36086 9.98087C5.08457 9.98087 5.73371 10.1532 6.29114 10.4806C6.47605 10.2465 6.69484 10.0413 6.94029 9.87172C6.19914 9.38315 5.30886 9.13058 4.36086 9.13058C1.95343 9.13058 0 10.8769 0 12.79C0 13.4277 0.390572 13.7437 1.172 13.7437ZM7.37657 13.7437H14.5926C15.546 13.7437 16 13.4566 16 12.8246C16 11.3194 14.0983 9.14172 10.9846 9.14172C7.86486 9.14172 5.96343 11.3194 5.96343 12.8246C5.96343 13.4566 6.41714 13.7437 7.37657 13.7437ZM7.10086 12.8763C6.95143 12.8763 6.88829 12.8363 6.88829 12.7154C6.88829 11.7732 8.34743 10.0097 10.9846 10.0097C13.616 10.0097 15.0749 11.7732 15.0749 12.7154C15.0749 12.836 15.0177 12.8763 14.868 12.8763H7.10086Z"
                        fill="#535862"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_30_57669">
                        <rect width="16" height="16" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  154 Applicants
                </span>
                <span class="ct_skill_badge d-flex align-items-center gap-2">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.0013 7.9974C7.26797 7.9974 6.64019 7.73628 6.11797 7.21406C5.59575 6.69184 5.33464 6.06406 5.33464 5.33073C5.33464 4.5974 5.59575 3.96962 6.11797 3.4474C6.64019 2.92517 7.26797 2.66406 8.0013 2.66406C8.73464 2.66406 9.36241 2.92517 9.88464 3.4474C10.4069 3.96962 10.668 4.5974 10.668 5.33073C10.668 6.06406 10.4069 6.69184 9.88464 7.21406C9.36241 7.73628 8.73464 7.9974 8.0013 7.9974ZM2.66797 13.3307V11.4641C2.66797 11.0863 2.7653 10.7392 2.95997 10.4227C3.15464 10.1063 3.41286 9.86451 3.73464 9.6974C4.42352 9.35295 5.12352 9.09473 5.83464 8.92273C6.54575 8.75073 7.26797 8.66451 8.0013 8.66406C8.73464 8.66362 9.45686 8.74984 10.168 8.92273C10.8791 9.09562 11.5791 9.35384 12.268 9.6974C12.5902 9.86406 12.8486 10.1058 13.0433 10.4227C13.238 10.7396 13.3351 11.0867 13.3346 11.4641V13.3307H2.66797ZM4.0013 11.9974H12.0013V11.4641C12.0013 11.3418 11.9709 11.2307 11.91 11.1307C11.8491 11.0307 11.7684 10.953 11.668 10.8974C11.068 10.5974 10.4624 10.3725 9.8513 10.2227C9.24019 10.073 8.62352 9.99784 8.0013 9.9974C7.37908 9.99695 6.76241 10.0721 6.1513 10.2227C5.54019 10.3734 4.93464 10.5983 4.33464 10.8974C4.23464 10.953 4.15397 11.0307 4.09264 11.1307C4.0313 11.2307 4.00086 11.3418 4.0013 11.4641V11.9974ZM8.0013 6.66406C8.36797 6.66406 8.68197 6.53362 8.9433 6.27273C9.20464 6.01184 9.33508 5.69784 9.33464 5.33073C9.33419 4.96362 9.20375 4.64984 8.9433 4.3894C8.68286 4.12895 8.36886 3.99828 8.0013 3.9974C7.63375 3.99651 7.31997 4.12717 7.05997 4.3894C6.79997 4.65162 6.6693 4.9654 6.66797 5.33073C6.66664 5.69606 6.7973 6.01006 7.05997 6.27273C7.32264 6.5354 7.63641 6.66584 8.0013 6.66406Z"
                      fill="#535862"
                    />
                  </svg>
                  40 Matched
                </span>
              </div>
              <div class="ct_dash_nav ct_mt_40 pt-0">
                <ul>
                  <li>
                    <a class="active ct_fs_14">Job Description</a>
                  </li>
                  <li>
                    <a className="ct_fs_14">Applicants</a>
                  </li>
                  <li>
                    <a class="ct_fs_14">Matches</a>
                  </li>
                </ul>
              </div>
              {jobPostDetail?.company_bio &&
                <div class="ct_mt_30">
                  <h6 class="ct_section_title">About the Company</h6>
                  <p class="ct_fs_18 ct_darkblue_text ct_para_scroll ct_custom_scroll">
                    {jobPostDetail?.company_bio || ""}
                  </p>
                </div>
              }
              <div class="ct_mt_30">
                <h6 class="ct_section_title">About the Role</h6>
                <p class="ct_fs_18 ct_darkblue_text ct_para_scroll ct_custom_scroll">
                  {jobPostDetail?.about_role || ""}
                </p>
              </div>
              <div class="ct_mt_30">
                <h6 class="ct_section_title">Category</h6>
                <p class="ct_fs_18 ct_darkblue_text ct_para_scroll ct_custom_scroll">
                  {jobPostDetail?.category || ""}
                </p>
              </div>
              <div class="ct_mt_30">
                <h6 class="ct_section_title">Industry</h6>
                <p class="ct_fs_18 ct_darkblue_text ct_para_scroll ct_custom_scroll">
                  {jobPostDetail?.industry || ""}
                </p>
              </div>
              <div class="ct_mt_30">
                <h6 class="ct_section_title">Responsibilities</h6>
                <p class="ct_fs_18 ct_darkblue_text ct_para_scroll ct_custom_scroll">{jobPostDetail?.responsibility || ""}</p>
              </div>
              <div class="ct_mt_30">
                <h6 class="ct_section_title">Education</h6>
                <p class="ct_fs_18 ct_darkblue_text ct_para_scroll ct_custom_scroll mb-0">
                  {jobPostDetail?.education || ""}
                </p>
              </div>
              {jobPostDetail?.skills &&
                <div class="ct_mt_30">
                  <h6 class="ct_section_title">Skills</h6>
                  <div>
                    {jobPostDetail?.skills != "" &&
                      jobPostDetail?.skills?.split(",")?.map((item) => (
                        <span class="ct_skill_badge">{item || ""}</span>
                      ))}
                  </div>
                </div>
              }
              {jobPostDetail?.qualification &&
                <div class="ct_mt_30">
                  <h6 class="ct_section_title">Qualification</h6>
                  <ul class="ct_list ps-3">
                    {jobPostDetail?.qualification != "" &&
                      jobPostDetail?.qualification?.split(",")?.map((item) => (
                        <li>{item || ""}</li>
                      ))}
                  </ul>
                </div>
              }
              {jobPostDetail?.requirement &&
                <div className="ct_mt_30">
                  <h6 class="ct_section_title">Requirement</h6>
                  <ul class="ct_list ps-3">
                    {jobPostDetail?.requirement != "" &&
                      jobPostDetail?.requirement?.split(",")?.map((item) => (
                        <li>{item || ""}</li>
                      ))}
                  </ul>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default JobDetails;